// Copyright (c) 2015 Steven Sojka
/* eslint-disable */
import isFunction from 'lodash-es/isFunction';
import isObject from 'lodash-es/isObject';
import isString from 'lodash-es/isString';

export function isMethodOrPropertyDecoratorArgs(...args: any[]): boolean {
  return (
    args.length >= 2 &&
    isObject(args[0]) &&
    isString(args[1]) &&
    isFunction(args[0].constructor) &&
    args[0].constructor.prototype === args[0]
  );
}
